import * as React from "react";
const SvgFiRrPumpMedical = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-pump-medical_svg__a)">
      <path
        fill="#062147"
        d="m23.555 2.168-.732-.488A9.97 9.97 0 0 0 17.276 0h-4.775c-1.93 0-3.5 1.57-3.5 3.5v2.793c-2.978 1.209-5 4.158-5 7.417V19c0 2.757 2.243 5 5 5h6c2.757 0 5-2.243 5-5v-5.29c0-3.259-2.022-6.208-5-7.417V2h2.275c1.584 0 3.118.465 4.438 1.344l.732.488a1 1 0 1 0 1.109-1.664M11 3.5c0-.827.673-1.5 1.5-1.5h.5v4h-2zm7 10.21V19c0 1.654-1.346 3-3 3H9c-1.654 0-3-1.346-3-3v-5.29A6.04 6.04 0 0 1 10.151 8h3.699A6.04 6.04 0 0 1 18 13.71M15 14a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2H9a1 1 0 1 1 0-2h2v-2a1 1 0 1 1 2 0v2z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-pump-medical_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPumpMedical;
